export const projects = [
	{
		img: 'https://raw.githubusercontent.com/kkm980/bluemercury/master/image/Untitled.png',
		title: 'Bluemercury clone',
		des: 'This is a clone of a US based e-commerce website for cosmetic products build with HTML,CSS,JS,Express,Node.js and mongo DB. Have features which allows user live search, voice search',
		demo: '',
		live: 'https://bluemercuryclone.netlify.app/', // deployed link
		gitHub: 'https://github.com/Nitesh-Goshwami/bluemercury_3.0',
		technologies: ['MongoDB', 'Node Js', 'HTML', 'CSS', 'javaScript'],
	},
	{
		img: 'https://github.com/kkm980/bluemercury/blob/master/image/urban%20company.png?raw=true',
		title: 'Urban Company Clone',
		des: 'It is an online home services platform that allows skilled and experienced professionals to connect with users looking for specific services.',
		demo: '',
		live: 'https://urban-company.netlify.app/homepage',
		gitHub: 'https://github.com/Nitesh-Goshwami/Urban_Company_Clone',
		technologies: ['React', 'Redux', 'HTML', 'CSS', 'javaScript'],
	},
	{
		img: 'https://github.com/Nitesh-Goshwami/todoApp/blob/master/client/public/Images/homePage.png?raw=true',
		title: 'YouTube Clone',
		des: 'A responsive YouTube clone built with React, Redux, and Firebase. It includes video playback, infinite scrolling, search functionality, authentication, and dynamic UI components. Utilizes libraries like Axios, React Router, Moment, and React Bootstrap for a smooth user experience.',
		demo: '',
		live: 'https://ytclone-nitesh.web.app/',
		gitHub: 'https://github.com/Nitesh-Goshwami/ytclone-nitesh',
		technologies: [
			'React',
			'Redux',
			'Firebase',
			'React Router',
			'Bootstrap',
			'Axios',
			'Moment',
			'Numeral',
		],
	},
	{
		img: 'https://souvikdutta.netlify.app/upvan1.png',
		title: 'Upvan',
		des: 'This is a fullstack plant shop website inspired from a dribble design, built with react, redux, rtk, mui, gsap for backend im using express',
		demo: '',
		live: 'https://upvan.netlify.app/',
		gitHub: 'https://github.com/Nitesh-Goshwami/upVan',
		technologies: ['React', 'Redux', 'Mui', 'gsap', 'express'],
	},
	{
		img: 'https://github.com/Nitesh-Goshwami/job-tracker/blob/main/Screenshot%202025-08-10%20234900.png?raw=true',
		title: 'Job Tracker',
		des: 'A modern, full-stack job tracking application built with React frontend and Node.js/Express backend with MongoDB database. Now with user authentication and user-specific job tracking! Each user can only see and manage their own job applications, ensuring complete privacy and data isolation.',
		demo: '',
		live: 'https://nitesh-goshwami.github.io/job-tracker/',
		gitHub: 'https://github.com/Nitesh-Goshwami/job-tracker',
		technologies: ['React', 'JSX', 'CSS', 'javaScript', 'Express', 'Mongoose', 'Cursor'],
	},
	{
		img: 'https://github.com/Nitesh-Goshwami/Calculator_Project/blob/main/Images/Home.png?raw=true',
		title: 'Simple Calculator',
		des: 'A simple calculator to perform addition, subtraction, division, power etc. There is also backspace button feature in this. Tech stack used to build this website are HTML, CSS and JavaScript',
		demo: '',
		live: 'https://mycasio.netlify.app/',
		gitHub: 'https://github.com/Nitesh-Goshwami/Calculator_Project',
		technologies: ['HTML', 'CSS', 'javaScript'],
	},
	{
		img: 'https://github.com/Nitesh-Goshwami/proconnxt_anime/blob/master/public/Images/Homep.png?raw=true',
		title: 'Anime App',
		des: 'An application in which user can view all list of anime, can search anime, filter and save anime in watchlist for watching it later. User can search anime by their title, production house, voice actor',
		demo: '',
		live: 'http://proconnxt-anime.vercel.app/',
		gitHub: 'https://github.com/Nitesh-Goshwami/proconnxt_anime',
		technologies: ['React', 'Redux', 'Auth0', 'Material UI', 'React-slick'],
	},
];
